import { useEffect, useState } from 'react';

const useVisibilityChange = (cb) => {
  const [visibility, setVisibility] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setVisibility(false);
      } else {
        setVisibility(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    visibility & cb && cb();
  }, [visibility]);
  
  return [visibility];
};
export default useVisibilityChange